import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./FichaPrevia.css";
import { getFichaPublica, responderFichaPublica } from "../../services/citas";
import FormularioDatosPaciente, {
  validarDatosPaciente,
  armarPayloadPaciente,
} from "./FormularioDatosPaciente";

/**
 * Ficha previa a tu consulta (PÚBLICA, sin login).
 *
 * El paciente abre el link que le mandó el consultorio por WhatsApp.
 * - Sin alta: formulario completo.
 * - Con alta: solo los campos que faltan (los demás NO se muestran).
 * Lo que llena se guarda en la Agenda; el médico lo revisa al dar de alta.
 *
 * El formulario y sus validaciones viven en FormularioDatosPaciente
 * (el mismo que usa la página pública de agendamiento).
 */

const FichaPrevia = () => {
  const { token } = useParams();

  const [cargando, setCargando] = useState(true);
  const [ficha, setFicha] = useState(null);
  const [errorGeneral, setErrorGeneral] = useState("");
  const [enviado, setEnviado] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [erroresServidor, setErroresServidor] = useState({});

  const [datos, setDatos] = useState({});
  const [esParaMi, setEsParaMi] = useState(true);
  const [avisoAceptado, setAvisoAceptado] = useState(false);

  useEffect(() => {
    const cargar = async () => {
      const resp = await getFichaPublica(token);
      if (resp.ok) {
        setFicha(resp.data);
      } else {
        setErrorGeneral(resp.data?.error || "No se pudo abrir la ficha.");
      }
      setCargando(false);
    };
    cargar();
  }, [token]);

  const handleEnviar = async (e) => {
    e.preventDefault();
    setErroresServidor({});

    const campos = ficha?.campos || [];
    if (!validarDatosPaciente({ campos, datos, esParaMi, avisoAceptado })) return;

    // Solo mandamos lo que la ficha pidió
    const payload = armarPayloadPaciente({ campos, datos, esParaMi });

    setEnviando(true);
    const resp = await responderFichaPublica(token, payload);
    setEnviando(false);

    if (resp.ok) {
      setEnviado(resp.data?.mensaje || "¡Listo! Tu ficha fue enviada al consultorio.");
      return;
    }

    // Error de estado (vencida, ya llenada, etc.)
    if (resp.data?.motivo) {
      setErrorGeneral(resp.data.error);
      return;
    }

    // Errores por campo del backend
    setErroresServidor(resp.data || {});
  };

  // ======== Pantallas ========

  if (cargando) {
    return (
      <div className="ficha-pagina">
        <div className="ficha-tarjeta"><p>Cargando…</p></div>
      </div>
    );
  }

  if (errorGeneral) {
    return (
      <div className="ficha-pagina">
        <div className="ficha-tarjeta">
          <h2 className="ficha-titulo">Ficha previa a tu consulta</h2>
          <p className="ficha-mensaje">{errorGeneral}</p>
        </div>
      </div>
    );
  }

  if (enviado) {
    return (
      <div className="ficha-pagina">
        <div className="ficha-tarjeta">
          <h2 className="ficha-titulo">{ficha?.titulo}</h2>
          <p className="ficha-mensaje ficha-mensaje-ok">✅ {enviado}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="ficha-pagina">
      <form className="ficha-tarjeta" onSubmit={handleEnviar}>
        <h2 className="ficha-titulo">{ficha.titulo}</h2>
        <p className="ficha-subtitulo">
          Consultorio de <strong>{ficha.medico_nombre}</strong>
        </p>
        <p className="ficha-ayuda">
          {ficha.con_alta
            ? "Ayúdanos a completar los datos que nos faltan."
            : "Llena tus datos antes de tu consulta para agilizar tu atención."}
        </p>

        <FormularioDatosPaciente
          campos={ficha.campos || []}
          datos={datos}
          setDatos={setDatos}
          esParaMi={esParaMi}
          setEsParaMi={setEsParaMi}
          avisoUrl={`/aviso-privacidad/ficha/${token}`}
          avisoTexto={ficha.aviso_privacidad?.texto}
          avisoAceptado={avisoAceptado}
          setAvisoAceptado={setAvisoAceptado}
          erroresServidor={erroresServidor}
        />

        <button type="submit" className="ficha-boton" disabled={enviando}>
          {enviando ? "Enviando…" : "Enviar ficha"}
        </button>
      </form>
    </div>
  );
};

export default FichaPrevia;